// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NRxvw","label":"styles_label__3pKN1"};